/* eslint-disable no-underscore-dangle */
/* eslint-disable camelcase */
import validate from 'validate.js';
import { toString } from 'lodash';
import { detectAnyAdblocker } from 'just-detect-adblock';
import 'bootstrap-select';

import { getCookie, setCookie } from './cookies';
import { showErrorsForInput, showErrors } from './validate';
import { latinizeForm } from './string';
// import showBSModal from '../vendor/bootstrap-modal-wrapper/bootstrap.modal.wrapper';
import cioIdentify from './customer-io';

const licenseServer = window.location.host.includes('stg') ?
  '//qlik-stg.anychart.com/licenses-checker/v3/pair' :
  '//qlik.anychart.com/licenses-checker/v3/pair';

$.fn.selectpicker.Constructor.BootstrapVersion = '3';

function removeSenselessFields([key]) {
  const senselessFields = ['oid', 'retURL', '00NA0000001qHx1', 'gaui', 'sfga'];
  return !senselessFields.includes(key);
}

function formDataMessage([key, value]) {
  return `<b>${key}</b>: ${value}`;
}

function getTgMessage(data, isAdblocker, error) {
  if (error) {
    const entries = Object.entries(data)
      .filter(removeSenselessFields)
      .map(formDataMessage)
      .join('\n');

    return `<b>[❌ ERROR]</b>
<b>Error message:</b> ${error.message}
<b>GTM: </b> ${window.google_tag_manager ? 'loaded' : 'undefined'}
<b>Customer.io: </b> ${window._cio ? 'loaded' : 'undefined'}
<b>AdBlock(Browser only): </b> ${isAdblocker ? 'enabled' : 'disabled'}

${entries}`;
  }

  let source = data.lead_source ? data.lead_source : data.source;
  if (!source) {
    source = window.location;
  }

  return `<b>[✅ SUCCESS]</b>
<b>source: </b>${source}
<b>email: </b>${data.email}`;
}

const commonConstraints = {
  first_name: {
    presence: true
  },
  last_name: {
    presence: true
  },
  email: {
    presence: true,
    email: {
      message: '^%{value} is not a valid email'
    }
  },
  phone: {
    presence: true,
    format: {
      pattern: /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/,
      message(value) {
        return validate.format('^%{num} is not a valid phone number', {
          num: value
        });
      }
    },
    length: {
      minimum: 8,
      maximum: 20,
      tooLong: 'number is too long (maximum is %{count} characters)',
      tooShort: 'number is too short (minimum is %{count} characters)'

    }
  },
  company: {
    presence: true
  },
  industry: {
    presence: true
  },
  role: {
    presence: true
  },
  '00NA0000001qHx1': {
    length: {
      minimum: 1,
      message: '^You need to select at least one extension'
    }
  },
  details: {
    presence: true
  },
  title: {
    presence: true
  }
};

// const errorMessage = err => `<div class="modal-body pd-0x">
//     <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
//     <div class="is-flex">
//       <div class="col-md-5 pd-1i5x pd-t-2x text-center bg-warning">
//         <h4 class="modal-title mg-b-0i5x text-white">Error!</h4>
//       </div>
//       <div class="col-md-7 pd-1i5x pd-t-2x">
//         ${err}
//       </div>
//     </div>
//   </div>`;

/**
 * @param interestValue
 */
function getSources(data, interestValue) {
  const {
    email,
    source,
    cio_event,
    subject,
    details
  } = data;
  const interest = toString(interestValue);
  const sources = {
    'OEM/SaaS/Enterprise Request': ['oem_request'],
    'Trial Download': ['trial_download'],
    'Qlik Trial Download': ['qlik_download', { qlik_interest: interest }],
    'Qlik Request Demo': ['qlik_request_demo'],
    'Qlik Request Quote': ['qlik_request_quote'],
    'Qlik Demo Access': ['qlik_demo_access_request'],
    'Qlik Demo App': ['qlik_demo_app_request'],
    'Qlik Request License': [cio_event, { subject, details }],
    'Qlik Request Support': ['qlik_request_support', { subject, details }],
    'Free Request': ['free_request'],
    'Qlik Webinars': ['qlik_webinar_video_request'],
    HoldOnStranger: ['HoldOnStranger', { from_page: window.location.href }]
  };
  if (data.checkLicense && !data.key) {
    return fetch(licenseServer, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email })
    })
      .then(res => res.json())
      .then(result => {
        const { key } = result;
        if (key && key.length === 32) {
          sources[source][1].key = key;
          return sources;
        }
        throw result.message;
      });
  }
  if (data.key) {
    sources[source][1].key = data.key;
  }
  return Promise.resolve(sources);
}

function getInterestValue(form) {
  return form['00NA0000001qHx1'].tagName === 'SELECT'
    ? Array.from(form['00NA0000001qHx1'].options)
      .filter(({ selected }) => selected)
      .map(({ value }) => value)
    : form['00NA0000001qHx1'].value;
}

function objectFromFormData(formData) {
  return Array.from(formData.entries())
    .reduce((memo, [key, value]) => ({
      ...memo,
      [key]: value
    }), {});
}

/**
 * @param formData
 */
async function getDemoCredentials(formData) {
  return fetch('demo-request.php', {
    method: 'POST',
    body: formData
  }).then(res => res.json()).then(result => result);
}

/**
 * @this {*}
 * @param {HTMLFormElement} form
 * @param constraints
 */
function inputValidation(form, constraints) {
  const errors = validate(form, constraints) || {};
  showErrorsForInput(this, errors[this.name]);
  if (form.submitBtn) {
    if (!Object.keys(errors).length) {
      form.submitBtn.classList.remove('disabled');
    } else {
      form.submitBtn.classList.add('disabled');
    }
  }
}

/**
 * @param {HTMLFormElement} form
 * @param data
 * @param constraints
 */
function setFormValues(form, data, constraints) {
  if (form && data) {
    const formFields = Object.values(form).map(el => el.id);
    formFields.forEach(key => {
      if (data[key] && !form[key].readOnly) {
        form[key].value = data[key];
        inputValidation.call(form[key], form, constraints);
      }
      if (data[key] && form[key].tagName === 'SELECT') {
        $(form[key]).selectpicker('refresh');
      }
    });
  }
}

/**
 * @param formId
 * @param cb
 */
export default function formHandler(formId, cb = () => { }) {
  detectAnyAdblocker().then(isAdblocker => {
    const form = formId ? document.getElementById(formId) : document.forms[1];
    if (form) {
      if (isAdblocker) {
        const alert = document.createElement('div');
        alert.classList.add('text-danger');
        alert.textContent = 'Please disable AdBlock to send the request. ' +
          'We can’t guarantee we receive your request when AdBlock is enabled.';
        form.before(alert);
      }
      const formFields = Object.values(form).map(el => el.id);
      const constraints = {};

      formFields.forEach(key => {
        if (key !== '' && Object.prototype.hasOwnProperty.call(commonConstraints, key)) {
          constraints[key] = commonConstraints[key];
        }
      });

      const cioFallbackData = getCookie('cio_fallback');
      if (cioFallbackData && form.autocomplete === 'on') {
        setFormValues(form, JSON.parse(cioFallbackData), constraints);
      }
      form.gaui.value = getCookie('GAUI');
      const countryField = document.getElementById('country');
      if (countryField && countryField.tagName === 'SELECT') {
        const countryValue =
          document.querySelector(`option[data-rel=${window.app.countryCode}]`).value;
        form.country.value = countryValue;
        $(form.country).selectpicker('refresh');
      }

      form.submitBtn.style.pointerEvents = 'all';
      form.submitBtn.addEventListener('click', () => {
        const errors = validate(form, constraints) || {};
        showErrors(form, errors);
      });

      // Hook up the inputs to validate on the fly
      const inputs = document.querySelectorAll('input, textarea, select');
      Array.from(inputs).forEach(input => {
        input.addEventListener('input', inputValidation.bind(input, form, constraints));
        input.addEventListener('change', inputValidation.bind(input, form, constraints));
      });

      form.addEventListener('submit', async event => {
        event.preventDefault();

        latinizeForm(form);
        const interestValue = getInterestValue(form);
        setCookie(window.app.cookieName, ((new Date()).getTime() / 1000) + (86400 * 2100));
        const formData = new FormData(form);
        const data = objectFromFormData(formData);

        data['00NA0000001qHx1'] = toString(interestValue);

        if (form.retURL.value === '') {
          form.retURL.value = window.location.origin;
        }

        if (window.location.href.includes('demos/schedule')) {
          const {
            first_name: { value: first_name },
            last_name: { value: last_name },
            email: { value: email }
          } = form;
          form.retURL.value = `${window.location.origin}${window.location.pathname}scheduler/${window.location.search}`;
          form.retURL.value += `${(window.location.search) ? '&' : '?'}first_name=${first_name}&last_name=${last_name}&email=${email}`;
        }
        if (window.location.href.includes('demos/cloud')) {
          const credentials = await getDemoCredentials(formData);
          data.qlik_demo_access_user = credentials.user;
          data.qlik_demo_access_pass = credentials.pass;
        }

        // if (window.location.href.includes('request/license')) {
        //   form.submit();
        // }

        if (data.lead_source) {
          data.source = data.lead_source;
        }

        if (!form.dataset.skipCio) {
          const tgData = new FormData();
          tgData.append('chatId', -1001586448939);
          tgData.append('isHtml', true);
          try {
            // send cio data (latinized)
            cioIdentify(data);

            const sources = await getSources(data, interestValue);
            window._cio.track(...sources[data.source]);
            cb();

            tgData.append('message', getTgMessage(data, isAdblocker));
          } catch (error) {
            tgData.append('message', getTgMessage(data, isAdblocker, error));
          } finally {
            // send form data to the tg
            await fetch('/webhooks/message/', {
              method: 'POST',
              body: tgData
            });
            form.submit();
          }
        }

        if (form.dataset.skipCio) {
          form.submit();
        }
      });
    }
  });
}
